import { usePostRest } from 'common/hooks';
import { ApiPaths } from '../constants/apiPaths';
import Yup from 'utils/validation';

export const cancelBookingSchema = Yup.object({
  conversationId: Yup.string().required()
});

export type APICancelBooking = Yup.InferType<typeof cancelBookingSchema>;

export const useCancelBooking = () =>
  usePostRest<void, APICancelBooking>(ApiPaths.CANCEL_BOOKING);
